<template>
  <div>
    <!-- BEGIN: HTML Table Data -->
    <div class="intro-y box p-5 mt-5">
      <div class="flex flex-col sm:flex-row sm:items-end xl:items-start">
        <form id="tabulator-html-filter-form" class="xl:flex sm:mr-auto">
          <div class="grid grid-cols-12 gap-x-2">
            <div class="col-span-6 md:col-span-4 xl:col-span-3 my-1">
              <div class="flex items-center sm:mr-2">

                <label class="mr-2">Field</label>
                <select id="tabulator-html-filter-field" v-model="filter.field" class="form-select">
                  <option value="lab_name">Lab Name</option>
                  <option value="lab_code">Lab Code</option>
                </select>
              </div>
            </div>
            <div class="col-span-6 md:col-span-3 xl:col-span-2 my-1">
              <div class="flex items-center sm:mr-2">

                <label class="mr-2">Type</label>
                <select id="tabulator-html-filter-type" v-model="filter.type" class="form-select w-fullo">
                  <option value="like" selected>like</option>
                  <option value="=">=</option>
                  <option value="<">&lt;</option>
                  <option value="<=">&lt;=</option>
                  <option value=">">></option>
                  <option value=">=">>=</option>
                  <option value="!=">!=</option>
                </select>
              </div>
            </div>
            <div class="col-span-6 md:col-span-4 xl:col-span-3 my-1">
              <div class="flex items-center sm:mr-2">

                <label class="mr-2">Value</label>
                <input id="tabulator-html-filter-value" v-model="filter.value" type="text" class="form-control sm:w-40"
                  placeholder="Search..." />
              </div>
            </div>
            <div class="col-span-3 md:col-span-2 xl:col-span-1 my-1">
              <button id="tabulator-html-filter-go" type="button" class="btn btn-primary w-full" @click="onFilter">
                Go
              </button>
            </div>
            <div class="col-span-3 md:col-span-2 xl:col-span-1 my-1">
              <button id="tabulator-html-filter-reset" type="button" class="btn btn-secondary w-full"
                @click="onResetFilter">
                Reset
              </button>
            </div>
          </div>
        </form>
        <div class="flex mt-5 sm:mt-0">
          <a href="javascript:;" data-toggle="modal" data-target="#new-order-modal"
            class="btn btn-primary shadow-md mr-2" @click="resetID">New Lab Cert</a>
          <div class="dropdown w-1/2 sm:w-auto">
            <button class="dropdown-toggle btn btn-outline-secondary w-full sm:w-auto" aria-expanded="false">
              <FileTextIcon class="w-4 h-4 mr-2" /> Export
              <ChevronDownIcon class="w-4 h-4 ml-auto sm:ml-2" />
            </button>
            <div class="dropdown-menu w-40">
              <div class="dropdown-menu__content box dark:bg-dark-1 p-2">
                <a id="tabulator-export-csv" href="javascript:;"
                  class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
                  @click="onExportCsv">
                  <FileTextIcon class="w-4 h-4 mr-2" /> Export CSV
                </a>
                <a id="tabulator-export-json" href="javascript:;"
                  class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
                  @click="onExportJson">
                  <FileTextIcon class="w-4 h-4 mr-2" /> Export JSON
                </a>
                <a id="tabulator-export-xlsx" href="javascript:;"
                  class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
                  @click="onExportXlsx">
                  <FileTextIcon class="w-4 h-4 mr-2" /> Export XLSX
                </a>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="overflow-x-auto scrollbar-hidden">
        <div id="tabulator" ref="tableRef" class="mt-5 table-report table-report--tabulator"></div>
      </div>
    </div>
    <!-- END: HTML Table Data -->

    <!-- Add Lab Cert modal-->

    <div id="new-order-modal" class="modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="font-medium text-base mr-auto">New Lab Cert</h2>
          </div>
          <div class="modal-body grid grid-cols-12 gap-4 gap-y-3">
            <div class="col-span-12">
              <label for="pos-form-1" class="form-label">Lab Cert Name</label>
              <input id="pos-form-1" v-model="labForm.lab_name" name="lab_name" type="text" class="form-control flex-1"
                :class="{ 'border-theme-6': validate.lab_name.$error }" placeholder="Lab Cert name" />
              <template v-if="validate.lab_name.$error">
                <div v-for="(error, index) in validate.lab_name.$errors" :key="index" class="text-theme-6 mt-2">
                  {{ error.$message }}
                </div>
              </template>
            </div>
            <div class="col-span-12">
              <label for="pos-form-2" class="form-label">Code</label>
              <input id="pos-form-2" v-model="labForm.lab_code" name="lab_code" type="text" class="form-control flex-1"
                :class="{ 'border-theme-6': validate.lab_code.$error }" placeholder="Code" />
              <template v-if="validate.lab_code.$error">
                <div v-for="(error, index) in validate.lab_code.$errors" :key="index" class="text-theme-6 mt-2">
                  {{ error.$message }}
                </div>
              </template>
            </div>

            <div class="col-span-12">
              <label for="pos-form-3" class="form-label">Order</label>
              <input id="pos-form-3" type="text" name="order" v-model="labForm.order" class="form-control flex-1"
                :class="{ 'border-theme-6': validate.order.$error }" placeholder="" />
              <template v-if="validate.order.$error">
                <div v-for="(error, index) in validate.order.$errors" :key="index" class="text-theme-6 mt-2">
                  {{ error.$message }}
                </div>
              </template>
            </div>
            <div class="col-span-12 flex items-center mt-2">
              <input
                id="pos-form-default"
                type="checkbox"
                v-model="labForm.default"
                class="form-check-input mr-2"
              />
              <label for="pos-form-default" class="form-label cursor-pointer">
                Set as Default Lab
              </label>
            </div>
          </div>
          <div class="modal-footer text-right">
            <button type="button" data-dismiss="modal" class="btn btn-outline-secondary w-32 mr-1">
              Cancel
            </button>
            <button type="button" class="btn btn-primary w-32" @click="submitForm">
              Save Details
            </button>
            <!-- <button type="button" v-if="labForm.id != ''" class="btn btn-danger w-32 ml-1" @click="deleteItem">
              Delete
            </button> -->
          </div>
        </div>
      </div>
    </div>

    <div id="success-notification-content" class="toastify-content hidden flex">
      <CheckCircleIcon class="text-theme-9" />
      <div class="ml-4 mr-4">
        <div class="font-medium">Details saved successfully!</div>
        <div class="text-gray-600 mt-1">

        </div>
      </div>
    </div>
    <!-- END: Success Notification Content -->
    <!-- BEGIN: Failed Notification Content -->
    <div id="failed-notification-content" class="toastify-content hidden flex">
      <XCircleIcon class="text-theme-6" />
      <div class="ml-4 mr-4">
        <div class="font-medium">Something went wrong!</div>
        <div class="text-gray-600 mt-1">
          Please check the fileld form.
        </div>
      </div>
    </div>
    <!-- END: Failed Notification Content -->
  </div>

</template>

<script setup>
/* eslint-disable */
import { defineComponent, ref, reactive, toRefs, onMounted } from 'vue'
import xlsx from 'xlsx'
import feather from 'feather-icons'
import Tabulator from 'tabulator-tables'
import Toastify from 'toastify-js'
import {
  required,
  integer
} from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import axios from 'axios'
import { BASE_URL } from '@/constants/config.js'
import Swal from "sweetalert2";
import router from '@/router'


const tableRef = ref()
const tabulator = ref()

const filter = reactive({
  field: 'lab_name',
  type: 'like',
  value: ''
})

const labForm = reactive({
  lab_name: '',
  lab_code: '',
  lab_group: '',
  default: false,
  order: '',
  id: ''
})

const rules = {
  lab_name: {
    required,
  },
  lab_code: {
    required,
  },
  order: {
    integer
  }
}

const validate = useVuelidate(rules, toRefs(labForm))

const initTabulator = () => {
  tabulator.value = new Tabulator(tableRef.value, {
    ajaxURL: BASE_URL + 'api/master/get_lab_details',
    ajaxConfig: {
      method: "GET", //set request type to Position
      headers: {
        "Content-type": 'application/json; charset=utf-8', //set specific content type
        "Authorization": "Bearer " + localStorage.getItem("token")
      },
    },
    ajaxFiltering: true,
    ajaxSorting: true,
    printAsHtml: true,
    printStyled: true,
    pagination: 'remote',
    paginationSize: 20,
    paginationSizeSelector: [10, 20, 30, 40],
    layout: 'fitColumns',
    headerSort: true,
    responsiveLayout: 'collapse',
    placeholder: 'No matching records found',
    columns: [
      {
        formatter: 'responsiveCollapse',
        width: 40,
        minWidth: 30,
        hozAlign: 'center',
        resizable: false,
        headerSort: false
      },

      // For HTML table
      {
        title: 'Lab Cert Name',
        minWidth: 100,
        responsive: 0,
        field: 'lab_name',
        vertAlign: 'middle',
        print: false,
        download: false,

      },

      {

        title: 'Lab Cert Code',
        minWidth: 100,
        field: 'lab_code',
        hozAlign: 'center',
        vertAlign: 'middle',
        print: false,
        download: false
      },
      {
        title: 'Order',
        minWidth: 100,
        field: 'lab_order',
        hozAlign: 'center',
        vertAlign: 'middle',
        print: false,
        download: false
      },
      {
        title: 'Default',
        minWidth: 100,
        field: 'default',
        hozAlign: 'center',
        vertAlign: 'middle',
        print: false,
        download: false,
        formatter(cell) {
          return `<div class="flex items-center lg:justify-center ${cell.getData().default == 1 ? "text-theme-9" : "text-theme-6"
            }">
                ${cell.getData().default == 1 ? "Yes" : "No"
            }
              </div>`
        }
      },
      {
        title: 'Status',
        minWidth: 100,
        field: 'active_status',
        hozAlign: 'center',
        vertAlign: 'middle',
        print: false,
        download: false,
        formatter(cell) {

          const a = cash(`<div class="flex items-center lg:justify-center ${cell.getData().active_status == 1 ? "text-theme-9" : "text-theme-6"
            }">
                ${cell.getData().statusText
            }
              </div>`)
          cash(a).on('click', function () {

              deleteItem(cell.getData().id, cell.getData().active_status);
          })

          return a[0]
        }
      },
      {
        title: 'Actions',
        minWidth: 100,
        field: 'actions',
        responsive: 1,
        hozAlign: 'center',
        vertAlign: 'middle',
        print: false,
        download: false,
        formatter(cell) {
          const a = cash(`<div class="flex lg:justify-center items-center">
                <a class="flex items-center mr-3" href="javascript:;">
                  <i data-feather="check-square" class="w-4 h-4 mr-1"></i> Edit
                </a>

              </div>`)
          cash(a).on('click', function () {
            getDetails(cell.getData().id);
          })

          return a[0]
        }
      },
      {
        title: 'Rates',
        minWidth: 50,
        field: 'actions',
        responsive: 1,
        hozAlign: 'center',
        vertAlign: 'middle',
        print: false,
        download: false,
        formatter(cell) {
          const a = cash(`<div class="btn btn-primary btn-sm py-2">Rates</div>`)
          cash(a).on('click', function() {
            //getDetails(cell.getData().id);
            router.push("/master/lab-certificate/rates/" + window.btoa(cell.getData().id));
          })

          return a[0]
        }
      },

      // For print format
      {
        title: 'Lab Cert Name',
        field: 'lab_name',
        visible: false,
        print: true,
        download: true
      },
      {
        title: 'Lab Cert Code',
        field: 'lab_code',
        visible: false,
        print: true,
        download: true
      },
      {
        title: 'Status',
        field: 'statusText',
        visible: false,
        print: true,
        download: true
      },

    ],
    renderComplete() {
      feather.replace({
        'stroke-width': 1.5
      })
    }
  })
}

// Redraw table onresize
const reInitOnResizeWindow = () => {
  window.addEventListener('resize', () => {
    tabulator.value.redraw()
    feather.replace({
      'stroke-width': 1.5
    })
  })
}

// Filter function
const onFilter = () => {
  tabulator.value.setFilter(filter.field, filter.type, filter.value)
}

const getDetails = (id) => {
  // console.log(id);
  const params = {
    "id": id,
  };

  let promise = axios({
    url: "api/master/get_lab_details_by_id",
    method: "POST",
    params: params,
    baseURL: BASE_URL,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
    config: { headers: { Accept: "application/json" } }
  });
  return promise
    .then(result => result.data)
    .then(data => {

      // console.log(data);

      if (data.success == false) {
        Swal.fire({
          html: data.message,
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Try again!",
          heightAuto: false,
          customClass: {
            confirmButton: "btn fw-semobold btn-light-danger",
          },
        }).then(() => {
          return;
        });
      } else {

        let item = data.data

        labForm.lab_name = item.lab_name;
        labForm.lab_code = item.lab_code;
        labForm.order = item.lab_order;
        labForm.default = item.default == 1;
        labForm.id = item.id;

        cash('#new-order-modal').modal('show')
      }


    })
    .catch(_error => {

      Swal.fire({
          html: "Server Error",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Try again!",
          heightAuto: false,
          customClass: {
            confirmButton: "btn fw-semobold btn-light-danger",
          },
        }).then(() => {
          return;
        });
    });
}

const submitForm = () => {
  validate.value.$touch()
  if (validate.value.$invalid) {
    Toastify({
      node: cash('#failed-notification-content')
        .clone()
        .removeClass('hidden')[0],
      duration: 3000,
      newWindow: true,
      close: true,
      gravity: 'top',
      position: 'right',
      stopOnFocus: true
    }).showToast()
  } else {


    const params = {
      "lab_name": labForm.lab_name,
      "lab_code": labForm.lab_code,
      "lab_group": labForm.lab_group,
      "lab_order": labForm.order,
      "default": labForm.default,
      "id": labForm.id
    };
    let promise_url = '';
    if (labForm.id != '' && labForm.id != null) {
      promise_url = "api/master/update_lab_details";
    } else {
      promise_url = "api/master/add_lab_details"
    }
    let promise = axios({
      url: promise_url,
      method: "POST",
      data: params,
      baseURL: BASE_URL,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      config: { headers: { Accept: "application/json" } }
    });
    return promise
      .then(result => result.data)
      .then(data => {

        if(data.success == false){

          Swal.fire({
            html: data.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Try again!",
            heightAuto: false,
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          }).then(() => {
            return;
          });

        } else {

          Toastify({
            node: cash('#success-notification-content')
              .clone()
              .removeClass('hidden')[0],
            duration: 3000,
            newWindow: true,
            close: true,
            gravity: 'top',
            position: 'right',
            stopOnFocus: true
          }).showToast()

          cash('#new-order-modal').modal('hide')

          tabulator.value.setFilter(filter.field, filter.type, filter.value)

          resetID();
          validate.value.$reset()

        }

      })
      .catch(_error => {

      });


  }

}
const resetID = () => {
  labForm.lab_name = '';
  labForm.lab_code = '';
  labForm.lab_group = '';
  labForm.default = false;
  labForm.order = '';
  labForm.id = '';
}

// On reset filter
const onResetFilter = () => {
  filter.field = 'lab_name'
  filter.type = 'like'
  filter.value = ''
  onFilter()
}

// Export
const onExportCsv = () => {
  tabulator.value.download('csv', 'data.csv')
}

const onExportJson = () => {
  tabulator.value.download('json', 'data.json')
}

const onExportXlsx = () => {
  const win = window
  win.XLSX = xlsx
  tabulator.value.download('xlsx', 'data.xlsx', {
    sheetName: 'Products'
  })
}

const deleteItem = async (id, status) => {
  try {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: `You are about to ${status == 1 ? 'deactivate' : 'activate'} this record!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel",
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    });

    if (!result.isConfirmed) return;

    const response = await axios.post(
      `${BASE_URL}api/master/delete_lab_details`,
      { id: id }, // ✅ send as body
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
          Accept: "application/json",
        },
      }
    );

    const data = response.data;

    if (!data.success) {
      await Swal.fire({
        html: data.message || "Something went wrong!",
        icon: "error",
        confirmButtonText: "Try again!",
        buttonsStyling: false,
        heightAuto: false,
        customClass: {
          confirmButton: "btn fw-semobold btn-light-danger",
        },
      });
      return;
    }

    await Swal.fire({
      html: data.message || "Record inactivated successfully!",
      icon: "success",
      confirmButtonText: "OK",
      buttonsStyling: false,
      heightAuto: false,
      customClass: {
        confirmButton: "btn fw-semobold btn-light-success",
      },
    });

    tabulator.value.setFilter(filter.field, filter.type, filter.value)

    // 🔁 Optional: refresh table / list
    // fetchItems();

  } catch (error) {

    await Swal.fire({
      html: "Server Error. Please try again later.",
      icon: "error",
      confirmButtonText: "Try again!",
      buttonsStyling: false,
      heightAuto: false,
      customClass: {
        confirmButton: "btn fw-semobold btn-light-danger",
      },
    });
  }
};


onMounted(() => {
  initTabulator()
  reInitOnResizeWindow()
})

</script>
